import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";

const DownloadShopQr = () => {
  const [shops, setShops] = useState([]);
  const [qrShop, setQrShop] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [showSMModal, setShowSMModal] = useState(false); // Added
  const qrModalRef = useRef();
  const [smShop, setSmShop] = useState(null); // Added

  useEffect(() => {
    const fetchShops = async () => {
      try {
        const res = await axios.get(
          "https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Create_Shops_ShopLists"
        );
        setShops(Array.isArray(res.data) ? res.data : []);
      } catch {
        setShops([]);
      }
    };
    fetchShops();
  }, []);

  const handleShowQR = (shop) => {
    setQrShop(shop);
    setShowQRModal(true);
  };

  const handleCloseQR = () => {
    setShowQRModal(false);
    setQrShop(null);
  };

  const handleShowSM = (shop) => {
    setSmShop(shop);
    setShowSMModal(true);
  };

  const handleCloseSM = () => {
    setShowSMModal(false);
    setSmShop(null);
  };

  // Download QR as image
  const handleDownloadQR = () => {
    const canvas = document.getElementById("shop-qr-canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${qrShop.shopCode}_qr.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // Generate QR value as URL with shopCode as query param
  const getQrValue = (shopCode, smname = "", smemail = "", smmobile = "") =>
    `https://mybankshoppy.com/leadsfromshops?shopCode=${encodeURIComponent(
      shopCode
    )}&smname=${encodeURIComponent(smname)}&smemail=${encodeURIComponent(
      smemail
    )}&smmobile=${encodeURIComponent(smmobile)}`;

  // Close QR modal on outside click
  useEffect(() => {
    if (!showQRModal) return;
    const handler = (e) => {
      if (qrModalRef.current && !qrModalRef.current.contains(e.target)) {
        handleCloseQR();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showQRModal]);

  return (
    <div className="container mt-4">
      {/* Stepper-style sub-navbar */}
      <div
        className="d-flex justify-content-between align-items-center mb-4"
        style={{ gap: 0 }}
      >
        <Link
          to="/createshop"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          1. Create Agent
        </Link>
        <Link
          to="/shoplist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          2. Agent List
        </Link>
        <Link
          to="/DownloadShopQr"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          3. Download QR
        </Link>

        <Link
          to="/shopleadslist"
          className="btn btn-outline-primary btn-sm flex-fill mx-1"
          style={{ borderRadius: "20px" }}
        >
          4. Leads List
        </Link>
      </div>
      <h3 className="mb-4">Download Agent QR</h3>
      <div className="table-responsive">
        <table className="table table-bordered table-striped align-middle">
          <thead className="table-light">
            <tr>
              <th>Agent Name</th>
              <th>Mobile Number</th>
              <th>Owner Name</th>
              <th>Agent Code</th>
              <th>QR</th>
            </tr>
          </thead>
          <tbody>
            {shops.toReversed().map((shop) => (
              <tr key={shop.id}>
                <td>
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    style={{ textDecoration: "underline", color: "#007bff" }}
                    onClick={() => handleShowSM(shop)}
                  >
                    {shop.shopname}
                  </button>
                </td>
                <td>{shop.contactnumber}</td>
                <td>{shop.ownername}</td>
                <td>{shop.shopCode}</td>
                <td>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleShowQR(shop)}
                  >
                    Generate QR
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* QR Modal */}
      {showQRModal && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            borderRadius: 0,
            zIndex: 1060,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            style={{ maxWidth: "95vw", width: 350 }}
          >
            <div
              className="modal-content"
              ref={qrModalRef}
              style={{
                borderRadius: 8,
                boxShadow: "none",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title" style={{ marginLeft: "120px" }}>
                  Agent QR
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseQR}
                ></button>
              </div>
              <div className="modal-body text-center">
                <QRCodeCanvas
                  id="shop-qr-canvas"
                  value={
                    qrShop
                      ? getQrValue(
                          qrShop.shopCode,
                          qrShop.smname,
                          qrShop.smemail,
                          qrShop.smmobile
                        )
                      : ""
                  }
                  size={180}
                  includeMargin={true}
                />
                <div className="mt-3">
                  <div style={{ display: "none" }}>
                    <strong>Shop Code:</strong> {qrShop?.shopCode}
                  </div>
                  <div>
                    <strong></strong> {qrShop?.shopname}
                  </div>
                  <div
                    className="small text-break mb-2"
                    style={{ display: "none" }}
                  >
                    <strong>QR URL:</strong>{" "}
                    {qrShop
                      ? getQrValue(
                          qrShop.shopCode,
                          qrShop.smname,
                          qrShop.smemail,
                          qrShop.smmobile
                        )
                      : ""}
                  </div>
                  <button
                    className="btn btn-primary mt-3"
                    onClick={handleDownloadQR}
                  >
                    Download QR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SM Modal */}
      {showSMModal && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            borderRadius: 0,
            zIndex: 1070,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-sm"
            style={{ maxWidth: "95vw", width: 350 }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: 8,
                boxShadow: "none",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title" style={{ marginLeft: "120px" }}>
                  SM Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseSM}
                ></button>
              </div>
              <div className="modal-body text-center">
                <div className="mb-2">
                  <strong>SM Name:</strong> {smShop?.smname || "N/A"}
                </div>
                <div className="mb-2">
                  <strong>SM Email:</strong> {smShop?.smemail || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadShopQr;
